import React from 'react';

import './style.scss';

const InfoLink = ({ href, classes, children, ...props }) => {
	const classList = ['info-link'];

	if (classes) {
		classList.push(classes);
	}

	return (
		<a className={classList.join(' ')} href={href} {...props}>
			{children}
		</a>
	);
};

export default InfoLink;
